module.exports = __webpack_public_path__ + "static/img/lwmb.3ad5623d.jpg";